import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { toOneDomainFilter } from './filters/to-one-domain-filter';
import { LocaleService } from './services/locale-service';
export var LocaleComponentNgModule = module(baseModuleId + ".locale", [])
    .service('localeService', LocaleService)
    .filter('toOneDomain', ['localeService', toOneDomainFilter]);
